/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles } from '@material-ui/core';
import Button from 'components/Button';
import { Formik } from 'formik';
import i18n from 'i18n';
import React from 'react';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import * as Yup from 'yup';
import styles from './styles';

const useStyles = makeStyles(styles);

const screenFields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: i18n.t('MINUTES_KEY'),
    stateKey: 'time_to_remove',
    isSelect: true,
    options: [
      { value: 1, label: `1 ${i18n.t('MINUTE_KEY')}` },
      { value: 5, label: `5 ${i18n.t('MINUTES_KEY')}` },
      { value: 10, label: `10 ${i18n.t('MINUTES_KEY')}` },
      { value: 15, label: `15 ${i18n.t('MINUTES_KEY')}` },
      { value: 20, label: `20 ${i18n.t('MINUTES_KEY')}` },
      { value: 40, label: `40 ${i18n.t('MINUTES_KEY')}` },
    ],
  },
  {
    gridXs: 12,
    label: i18n.t('MESSAGE_KEY'),
    stateKey: 'message',
    isMultiline: true,
  },
];

const validationSchema = Yup.object().shape({
  time_to_remove: Yup.number().required(i18n.t('REQUIRED_FIELD_KEY')),
  message: Yup.string()
    .trim()
    .required(i18n.t('REQUIRED_FIELD_KEY')),
});

export interface Props {
  onCancel: () => void;
  onSubmit: (values: any) => void;
}

export default function FormRemoveSession({ onCancel, onSubmit }: Props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Formik
        initialValues={{}}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ setFieldValue, submitForm, errors, values }) => (
          <Grid container spacing={2} data-testid={'autosky-formremovesession'}>
            <GenericForm
              fields={values}
              screenFields={screenFields}
              setFieldValue={setFieldValue}
              errors={errors}
            />
            <Grid container justify="flex-end" className={classes.buttonsBase}>
              <Grid container className={classes.buttonsAlign}>
                <Button id="submit-button" onClick={submitForm} submitButton>
                  {i18n.t('REMOVE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={onCancel}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Formik>
    </React.Fragment>
  );
}
